// extracted by mini-css-extract-plugin
export default {"contentLayout":"ContentLayout_contentLayout__kPQZ+"};